module.exports = __webpack_public_path__ + "static/media/adesivo.605511ad.png";